import { memo } from 'react'

import {
  HIERARCHY_TYPE_WITH_READONLY_LEGAL_INFO,
  PartnerHierarchyType,
} from 'clickNgo/entities/partner/configs'
import { useGetFormDataField } from 'cng-common/features/form'

import { LegalAddressBlock } from './components/legalAddressBlock/LegalAddressBlock'
import { LegalCommonBlock } from './components/legalCommonBlock/LegalCommonBlock'
import { IPartnerLegalInfoProps } from './models'

import styles from './PartnerLegalInfo.module.scss'

export const PartnerLegalInfo = memo<IPartnerLegalInfoProps>((props) => {
  const [hierarchyType] = useGetFormDataField<PartnerHierarchyType>(
    props.formKeys.basic,
    'hierarchyType'
  )

  const isDisabled = HIERARCHY_TYPE_WITH_READONLY_LEGAL_INFO.includes(hierarchyType)

  return (
    <div className={styles.container}>
      <LegalCommonBlock {...props} isDisabled={isDisabled} />
      <LegalAddressBlock {...props} isDisabled={isDisabled} />
    </div>
  )
})
